<template>
  <div class="app-main-content fba-order">
    <order-grid v-show="view==='list'" ref="orderGrid" view-source="fbaVerify" config-module="102" @refusePermission="refusePermission" @reviewRefusePermission="reviewRefusePermission" @rowDoubleClicked="toLook()">
      <div slot="operations">
        <el-button no="look" type="success" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
        <el-button v-if="false" no="new" type="primary" @click="toAdd()">{{ $t('common.btn.new') }}</el-button>
        <el-button v-if="false" no="clone" type="primary" @click="toCopy()">{{ $t('SeaExport.Clone') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAVerify_acceptFbaBookingOrder'])" no="approved" type="primary" @click="toApproved()">{{ $t('SeaExport.PassAudit') }}</el-button>
        <el-button v-if="$checkPermission(['button_FBAVerify_rejectFbaBookingOrder'])" no="refuse" type="primary" :disabled="rejectWindow.refuseState" @click="toRefuse()">{{ $t('SeaExport.Refuse') }}</el-button>
        <el-button v-if="isPretrialReviewFBA && $checkPermission(['button_FBAVerify_reviewThroughFbaBookingOrder'])" no="reApproved" type="primary" @click="toReApproved()">{{ $t('SeaExport.VerifyReviewThrough') }}</el-button>
        <el-button v-if="isPretrialReviewFBA && $checkPermission(['button_FBAVerify_reviewRefusalFbaBookingOrder'])" no="reRefuse" type="primary" :disabled="reviewRefuseState" @click="toReRefuse()">{{ $t('SeaExport.VerifyReviewRefusal') }}</el-button>
        <!-- <el-button no="edit" type="success" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>       -->
      </div>
    </order-grid>
    <order-workspace v-show="view==='detail'" ref="orderWorkspace" :parent-context="context" view-source="fbaVerify" @back="backToList" @copy="toCopy" />
    <!--    订舱审核-通过   -->
    <fba-op-verify-frame-dialog
      v-if="opVerifyFrameDialog.visible"
      :visible.sync="opVerifyFrameDialog.visible"
      :job-model="opVerifyFrameDialog.job || {}"
      :job-list="opVerifyFrameDialog.jobList || []"
      :submit-call-back="opVerifyFrameDialog.submitCallBack"
    />
    <op-verify-frame-reject
      v-if="rejectWindow.visible"
      :visible.sync="rejectWindow.visible"
      :job-no="rejectWindow.jobNo"
      type="fba"
      :reject-call-back="rejectWindow.rejectCallBack"
    />
    <job-copy-window :visible.sync="copyDialog.visible" lob="fba" @confirmCallBack="doCopyJob" />
  </div>
</template>

<script>
import orderGrid from './Order/orderGrid'
import orderWorkspace from './Order/orderWorkspace'
import { cacheName, cache } from '@/utils/cacheManager'
import FbaOpVerifyFrameDialog from '@/views/cargo/v0/FBA/FbaOpVerifyFrameDialog'
import { getLoading } from '@/utils/utilBaseElement'
import { approved, doCopyFbaJob } from '@/api/Fba/fbaJob'
import OpVerifyFrameReject from '@/views/cargo/v0/SeaExport/components/verify/OpVerifyFrameReject'
import { updNotSubmitOrSubmit } from '@/api/Fba/fbaJob'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { isContractExpiredForbidCreateJob } from '@/api/seaExport/seaExportJob'
import LocalStorageUtils from '@/utils/localStorageUtils'
import JobCopyWindow from '@/components/Cargo/Job/jobCopyWindow'
import { deepClone } from '@/utils'
export default {
  name: 'FBAVerify',
  components: { orderGrid, orderWorkspace, FbaOpVerifyFrameDialog, OpVerifyFrameReject, JobCopyWindow },
  data() {
    return {
      view: 'list',
      loading: null,
      context: {},
      isPretrialReviewFBA: false,
      btn: {
        pretrialReviewFBAConfig: false,
        pretrialReviewFBAThroughRole: true
      },
      // 拒绝
      rejectWindow: {
        visible: false,
        jobNo: '',
        uuid: '',
        rejectCallBack: null,
        refuseState: true
      },
      // 复核拒绝
      reviewRefuseState: true,
      opVerifyFrameDialog: { // 审核通过
        visible: false,
        job: null,
        jobList: [],
        submitCallBack: null
      },
      copyDialog: {
        visible: false,
        job: {}
      }
    }
  },
  computed: {
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.OFFICE_LIST, cacheName.OFFICE, cacheName.CONFIG)
    this.context.user = cache.user
    this.context.officeList = cache.officeList
    this.context.office = cache.office
    this.context.config = cache.config
    this.btn.pretrialReviewFBAConfig = parseInt(cache.config.get('PretrialReviewFBA')) === 1
    this.btn.pretrialReviewFBAThroughRole = this.$checkPermission(['button_fmVerify_reviewFBAThrough'])
    this.isPretrialReviewFBA = Number(cache.config.get('PretrialReviewFBA')) === 1
  },
  methods: {
    toLook() {
      const row = this.$refs.orderGrid.selectedItem
      if (!row || !row.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      this.detailHandle('look', row)
    },
    toEdit() {
      const row = this.$refs.orderGrid.selectedItem
      if (!row || !row.uuid) {
        this.$message.warning(this.$t('CargoMsg.SelectJob'))
        return
      }
      this.detailHandle('edit', row)
    },
    /**
     * 详情复制的话 curRow 有值
     * @param curRow
     */
    toCopy(curRow) {
      if (JobUtils.checkHQ()) {
        return
      }
      const row = curRow || this.$refs.orderGrid.selectedItem
      if (!row || !row.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBusiness'))
        return
      }
      if (row.customerId) {
        this.loading = getLoading()
        isContractExpiredForbidCreateJob(row.customerId).then(res => {
          this.loading.close()
          if (res.data) {
            this.$message.warning(this.$t('Message.ContractExpireCannotCreated'))
          } else {
            this.copyDialog.job = row
            const isShowView = LocalStorageUtils.getConfiguration('COPY_JOB_fba') // 是否显示复制选项弹框【勾选是true不显示】
            if (!isShowView) {
              this.copyDialog.visible = true
            } else {
              this.doCopyJob()
            }
          }
        })
      }
    },
    doCopyJob() {
      const item = {}
      item.jobRule = ''
      item.jobUuid = this.copyDialog.job.uuid
      item.branchId = this.$store.getters.currentOfficeId
      /* 复制哪些页签的数据 */
      item.vesselEq = false
      item.mbl = false
      item.hbl = false
      item.charge = LocalStorageUtils.getConfiguration('COPY_CHARGE_fba')
      item.prePlanBooking = false
      item.copyNum = LocalStorageUtils.getConfiguration('COPY_NUM_INPUTfba')
      item.all = false
      this.loading = getLoading()
      doCopyFbaJob(item).then(async res => {
        const newJob = res.data
        newJob.opOffice = this.$store.getters.currentOfficeId
        newJob.copyNum = item.copyNum
        this.detailHandle('copy', newJob)
      }).finally(() => {
        this.loading.close()
      })
    },
    toAdd() {
      this.detailHandle('add', { uuid: '' })
      if (this.view === 'detail') {
      } else {
        this.view = 'detail'
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = []
      if (this.view !== 'detail') {
        this.view = 'detail'
        rowData = this.$refs.orderGrid.rowData
      } else {
        rowData = this.$refs.orderWorkspace.rowData
      }
      this.$refs.orderWorkspace.onShow(type, rowData, row)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        this.$refs.orderGrid.toQueryList()
      }
    },
    // 审核通过
    toApproved() {
      const jobLists = this.$refs.orderGrid.getSelections()
      if (jobLists.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (jobLists.length > 50) {
        this.$message.warning(this.$t('SeaExport.BatchAuditBusinessTip'))
        return
      }
      const jobArr = []
      for (const fbaJob of jobLists) {
        if (fbaJob.jobState !== -1 || fbaJob.verifyState === 1 || fbaJob.verifyState === 2 || (this.isPretrialReviewFBA && (fbaJob.verifyState === 5 || fbaJob.verifyState === 6))) {
          jobArr.push(fbaJob.jobNo)
        }
      }
      if (jobArr.length > 0) {
        const str = this.isPretrialReviewFBA ? `${this.$t('Message.Approved')}/${this.$t('CargoMsg.Cargo_Denied')}/${this.$t('SeaExport.VerifyReviewThrough')}/${this.$t('SeaExport.ReviewRejectedBusinessNumber')}` : `${this.$t('Message.Approved')}/${this.$t('SeaExport.RejectedBusinessNumber')}`
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobArr.join(','))
        ])
        this.$alert(content, str)
        return
      }

      this.opVerifyFrameDialog.batchPassAudit = jobLists.length > 1
      this.opVerifyFrameDialog.job = jobLists[0]
      this.opVerifyFrameDialog.jobList = jobLists
      this.opVerifyFrameDialog.submitCallBack = this.batchAudit
      this.opVerifyFrameDialog.visible = true
    },
    // 审核通过
    batchAudit(result) {
      if (result) {
        const objList = deepClone(this.opVerifyFrameDialog.jobList)
        for (const element of objList) {
          Object.assign(element, result)
          element.jobState = 0
          element.verifyState = 1
        }
        result = objList
      }
      this.loading = getLoading()
      approved(result, this.$store.getters.currentOfficeId).then(res => this.approvedResultHandler(res)).finally(() => {
        this.loading.close()
      })
    },
    approvedResultHandler(res) {
      this.$message.success(this.$t('AirExport.ReviewSucceeded'))
      this.reloadFunc()
    },
    reloadFunc() {
      this.$refs.orderGrid.toQueryList()
      this.$refs.orderGrid.selectedItem = null
      this.$refs.orderGrid.gridOptions.api.clearFocusedCell()
    },
    // 拒绝
    toRefuse() {
      const selections = this.$refs.orderGrid.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (selections.length > 1) {
        this.$message.warning(this.$t('SeaExport.OnlyOne'))
        return
      }
      this.rejectWindow.jobNo = selections[0].jobNo
      this.rejectWindow.uuid = selections[0].uuid
      this.rejectWindow.rejectCallBack = this.rejectCallBackHandler
      this.rejectWindow.visible = true
    },
    // 复核通过
    toReApproved() {
      const selections = this.$refs.orderGrid.getSelections()

      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      const jobNos = []
      selections.forEach(item => {
        if (item.verifyState !== 1) {
          /* 有一个状态不是待审核就改为true 同时缓存他的委托单号*/
          jobNos.push(item.bookingNo)
        }
      })
      if (jobNos.length > 0) {
        const h = this.$createElement
        const content = h('div', null, [
          h('p', { style: 'overflow-wrap: break-word;' }, jobNos.join(','))
        ])
        this.$alert(content, this.$t('SeaExport.UnreviewedBusinessNumber2'))
        return
      }
      const keys = []
      selections.forEach(item => {
        keys.push(item.uuid)
      })
      this.loading = getLoading()
      updNotSubmitOrSubmit({ type: 'FBA_TO_REVIEW_ADOPT', keys: keys }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.$refs.orderGrid.toQueryList()
      }).finally(() => {
        this.loading.close()
      })
    },
    // 复核拒绝
    toReRefuse() {
      const selections = this.$refs.orderGrid.getSelections()
      if (selections.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectARecord'))
        return
      }
      if (selections.length > 1) {
        this.$message.warning(this.$t('SeaExport.OnlyOne'))
        return
      }
      this.rejectWindow.jobNo = selections[0].jobNo
      this.rejectWindow.uuid = selections[0].uuid
      this.rejectWindow.rejectCallBack = this.rejectsCallBackHandler
      this.rejectWindow.visible = true
    },
    reviewRefusePermission(state) {
      this.reviewRefuseState = state
    },
    refusePermission(state) {
      this.rejectWindow.refuseState = state
    },
    rejectCallBackHandler(remark) {
      this.loading = getLoading()
      updNotSubmitOrSubmit({ type: 'FBA_REFUSE', keys: [this.rejectWindow.uuid], verifyRefuseReason: remark }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.$refs.orderGrid.toQueryList()
      }).finally(() => {
        this.loading.close()
      })
    },

    rejectsCallBackHandler(remark) {
      this.loading = getLoading()
      updNotSubmitOrSubmit({ type: 'FBA_TO_REVIEW_REFUSE', keys: [this.rejectWindow.uuid], verifyRefuseReason: remark }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_Success'))
        this.$refs.orderGrid.toQueryList()
      }).finally(() => {
        this.loading.close()
      })
    }

  }

}
</script>

<style lang="scss">
</style>
